// helper mixin for immutable CRUD operations on a collection
const FormIsValidMixin = {
    methods: {
        $_formIsValid(formRef) {
            let isValid = true;

            formRef.fields.map(field => {
                if (field.validateState !== 'success') {
                    isValid = false;
                }
            });

            return isValid;
        },
    }
};
export default FormIsValidMixin;
